import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAlgoListDataCachedSelectedDay,
  getIsClientIdShow,
} from '../../../../stores/algos-list/getters';
import { algoBrokerChange } from '../../../../stores/algos-list/actions';
import { getIsBrokersFetching, getIsBrokersOk } from '../../../../reducers';
import { addNotification } from '../../../../actions/notifications';
import BrokerSelect from '../../../../components/light-weight/BrokerSelect';
import useBrokerDataAll from '../../../../hooks/useBrokerDataAll';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',

    '& .MuiFormControl-fullWidth': {
      minWidth: 226,
    },
  },
}));

const CellBroker = ({ row = {} }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;
  const isClientIdShow = useSelector(getIsClientIdShow);
  const brokersDataAll = useBrokerDataAll();

  const isMountedSetupBrokers = useSelector(getIsBrokersOk);
  const isFetchingSetupBrokers = useSelector(getIsBrokersFetching);

  const [isLoading, setLoading] = useState(false);

  const broker = useSelector((state) => {
    const { broker = '' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return broker;
  });

  const status = useSelector((state) => {
    const { status = '' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === _id) || {};

    return status;
  });

  const brokerChange = async (val) => {
    try {
      setLoading(true);
      await dispatch(algoBrokerChange(_id, val));

      dispatch(
        addNotification({
          type: 'success',
          message: 'Algo Broker changed successfully',
        })
      );
    } catch (err) {
      if (err && err.message && err.message === 'Network Error') {
        dispatch(
          addNotification({
            type: 'error',
            message: 'Algo Broker change failed',
          })
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={classes.root}>
      {isMountedSetupBrokers && !isFetchingSetupBrokers && (
        <BrokerSelect
          brokersDataAll={brokersDataAll}
          broker={broker}
          brokerChange={brokerChange}
          status={status}
          loading={isLoading}
          blurClientId={!isClientIdShow}
          readOnly={broker ? true : false}
        />
      )}
    </div>
  );
};

export default CellBroker;
